import { Fragment, useEffect, useState } from 'react';
import '../css/successPage.less';
import { useParams, useNavigate } from "react-router-dom";
import { Row, Col } from 'antd';
import ReactGA from 'react-ga';
import moment from 'moment';

const SuccessPage = ({ userName, refreshUserName, refreshInitialTimeStamp }) => {
  const [isWonderlicTest, setIsWonderlicTest] = useState(
    JSON.parse(localStorage.getItem("userData")) ? JSON.parse(localStorage.getItem("userData")).isWonderlicTest : null
  );
  const [isSendFormError, setIsSendFormError] = useState(
    JSON.parse(localStorage.getItem("userData")) ? JSON.parse(localStorage.getItem("userData")).isSendFormError : null
  );
  const { countryCode } = useParams();

  const navigate = useNavigate();
  const userData = JSON.parse(localStorage.getItem("userData"));
  const currentValidationStep = JSON.parse(localStorage.getItem("currentValidationStep"));
  const currentTestStep = JSON.parse(localStorage.getItem("currentTestStep"));
  const currentRevisionStep = JSON.parse(localStorage.getItem("currentRevisionStep"));

  if (!userData && currentValidationStep < 4 && currentTestStep < 3 && currentRevisionStep < 2) {
    navigate(`/examenes/psicologia/${countryCode}`);
  }

  const checkStatesAndReturn = () => {
    if (isWonderlicTest && (!isSendFormError || isSendFormError === false)) {
      setTimeout(() => {
        localStorage.clear();
        refreshUserName();
        navigate(`/examenes/psicologia/${countryCode}`);
      }, 30000);
    } else if (!isWonderlicTest && (!isSendFormError || isSendFormError === false)) {
      setTimeout(() => {
        localStorage.clear();
        refreshUserName();
        navigate(`/examenes/psicologia/${countryCode}`);
      }, 20000);
    } else {
      console.error('Error en envío de formulario:', isSendFormError);
    }

  };

  const sendAnalyticsSessionTime = () => {
    const getInitialTimeStamp = JSON.parse(localStorage.getItem("initialTimeStamp"));
    const getLastTimeStamp = JSON.parse(localStorage.getItem("timeStamp"));

    if (getInitialTimeStamp && getLastTimeStamp) {
      const startTime = moment(getInitialTimeStamp);
      const endTime = moment(getLastTimeStamp);
      const diff = moment.duration(endTime.diff(startTime));

      let hours = diff.hours().toString();
      if (hours.length === 1) {
        hours = `0${hours}`;
      }

      let minutes = diff.minutes().toString();
      if (minutes.length === 1) {
        minutes = `0${minutes}`;
      }

      let seconds = diff.seconds().toString();
      if (seconds.length === 1) {
        seconds = `0${seconds}`;
      }

      const finalTimeStamp = parseInt(`${hours}${minutes}${seconds}`);

      ReactGA.event({
        category: 'Psicología',
        action: 'Duración',
        label: userName,
        value: finalTimeStamp
      });
    }
  };

  useEffect(() => {
    ReactGA.initialize('UA-122192936-1');
    refreshInitialTimeStamp();
    sendAnalyticsSessionTime();

    window.scrollTo(0, 0);
    if (userData && currentValidationStep >= 4 && currentTestStep >= 3 && currentRevisionStep >= 2) {
      checkStatesAndReturn();
    }
  }, [isWonderlicTest, isSendFormError]);

  return (
    <Fragment>
      <Row justify="center">
        <Col lg={22} md={22}>
          {
            userData && !isWonderlicTest && !isSendFormError &&
            <Row justify="center" className="success-gray-container mt-100 pt-40 pb-40 pl-70 pr-70">
              <Col lg={24} md={24}>
                <h1 className="text-center mb-30">¡Has finalizado la evaluación de psicología!</h1>
                <h3 className="text-center mb-30">Por favor, <strong>dé aviso a su psicólogo/a</strong> para que le indique cómo continuar.</h3>
                <h4 className="text-center mb-0">¡Muchas gracias!</h4>
              </Col>
            </Row>
          }
          {
            userData && isWonderlicTest && !isSendFormError &&
            <Row justify="center" className="success-gray-container mt-100 pt-40 pb-40 pl-70 pr-70">
              <Col lg={24} md={24}>
                <h1 className="text-center mb-30">Test de inteligencia de Wonderlic</h1>
                <h3 className="mb-30">Ha finalizado la evaluación digital. Por favor, <strong>dé aviso a su psicólogo/a</strong> para que le indique cómo realizar el test de inteligencia de Wonderlic.</h3>
                <h4 className="text-center mb-0">¡Muchas gracias!</h4>
              </Col>
            </Row>
          }
          {
            userData && isSendFormError &&
            <Row justify="center" className="success-gray-container mt-100 pt-40 pb-40 pl-70 pr-70">
              <Col lg={24} md={24}>
                <h1 className="text-center mb-20">Error en el envío de formulario</h1>
                <h3 className="text-center mb-30">Por favor, <strong>dé aviso a su psicólogo/a</strong>. Le pedimos disculpas por el inconveniente.</h3>
                <h4 className="text-center mb-0">¡Muchas gracias!</h4>
              </Col>
            </Row>
          }
        </Col>
      </Row>
    </Fragment>
  )
};

export default SuccessPage;
